export default "__VITE_PUBLIC_ASSET__a7d7d2c2__"